import { useNavigate } from "react-router-dom";
import '../../styles/backbutton.css';

export default function BackButton() {
    const navigation = useNavigate();
    function handleClick() {
        navigation(-1)
    };
    return (
        <div className="header">
            <button onClick={handleClick}>X</button>
        </div>
    )
};